module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.Order.jobType == 'FTC') ? _c('div', [_c('p', [_vm._v("If needed, keep this half for your records")])]) : _c('div', [_c('p', [_vm._v("If needed, keep this half for your records")])]), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(3), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.accountType == 1 ? _vm.Account.primaryContact.firstName + ' ' + _vm.Account.primaryContact.lastName + ' ' + _vm.Account.primaryContact.suffix : _vm.Account.primaryContact.legalName) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Order.shippingFullName) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.Order.shippingAddressLineOne) + " " + _vm._s(_vm.Order.shippingAddressLineTwo) + " " + _vm._s(_vm.Order.shippingCity) + " " + _vm._s(_vm.Order.shippingState) + " " + _vm._s(_vm.Order.shippingPostcode))]), _vm._v(" "), _c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reDistPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.distancePD))])]), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reNearPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.nearPD))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leNearPD))]) : _vm._e()])])])]), _vm._v(" "), (_vm.Order.IncludeAdditionalRxFields) ? _c('div', [_c('table', [_c('tbody', [_c('tr'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reocHeight))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leocHeight))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lens Information")]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Frame Information")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.jobTypeDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Manufacturer")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameManufacturer))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Lens Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensTypeDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Brand")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameBrand))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Design")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensDesignDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Name/Model")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameModel))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Material")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensMaterialDescription))]), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Frame Type")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [(_vm.Order.jobType != 'UNC') ? _c('span', [_vm._v(_vm._s(_vm.Order.frameTypeDescription))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Treatment(s)")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, _vm._l((_vm.Order.lensTreatmentDescription), function(lensItem) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(lensItem))])])
  }), 0)]), _vm._v(" "), _c('tr', [(_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Color")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameColor))]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.Order.jobType != 'UNC') ? _c('th', [_vm._v("Eye Size")]) : _vm._e(), _vm._v(" "), (_vm.Order.jobType != 'UNC') ? _c('td', [_vm._v(_vm._s(_vm.Order.frameEyeSize))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('table', [_c('tbody', [_vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('table', [_c('tbody', [_vm._m(8), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone #")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("(866) 385-0447"))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet) + " " + _vm._s(_vm.Order.orderLab.shippingCity) + " " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])])]), _vm._v(" "), (_vm.Order.jobType == 'FTC') ? _c('div', {
    staticClass: "container"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(11), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.accountType == 1 ? _vm.Account.primaryContact.firstName + ' ' + _vm.Account.primaryContact.lastName + ' ' + _vm.Account.primaryContact.suffix : _vm.Account.primaryContact.legalName) + " ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Order.shippingFullName) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.Order.shippingAddressLineOne) + " " + _vm._s(_vm.Order.shippingAddressLineTwo) + " " + _vm._s(_vm.Order.shippingCity) + " " + _vm._s(_vm.Order.shippingState) + " " + _vm._s(_vm.Order.shippingPostcode))]), _vm._v(" "), _c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reDistPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.distancePD))])]), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.reNearPD))]) : _c('td', {
    staticClass: "order-confimation-description",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.Order.nearPD))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSph))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leCyl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAxis))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leAdd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leSegHeight))]), _vm._v(" "), (!_vm.Order.isOnly1DistancePD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leDistPD))]) : _vm._e(), _vm._v(" "), (!_vm.Order.isOnly1NearPD) ? _c('td', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.leNearPD))]) : _vm._e()])])])]), _vm._v(" "), _c('div', [(_vm.Order.AdditionalRXFields) ? _c('table', [_c('tbody', [_vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Right eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.reocHeight))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Left Eye")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leHorizontalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismValue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leVerticalPrismDirection))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.leocHeight))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', [_c('table', [_c('tbody', [_vm._m(16), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.jobTypeDescription))]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameManufacturer))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Lens Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensTypeDescription))]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameBrand))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Design")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensDesignDescription))]), _vm._v(" "), _c('th', [_vm._v("Name/Model")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameModel))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Material")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.lensMaterialDescription))]), _vm._v(" "), _c('th', [_vm._v("Frame Type")]), _vm._v(" "), _c('td', [(_vm.Order.jobType != 'UNC') ? _c('span', [_vm._v(_vm._s(_vm.Order.frameTypeDescription))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Treatment(s)")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, _vm._l((_vm.Order.lensTreatmentDescription), function(lensItem) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(lensItem))])])
  }), 0)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Color")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameColor))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Eye Size")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.frameEyeSize))])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "border": "5px dashed red"
    }
  }, [_c('tbody', [_vm._m(18), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderLab.name))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2",
      "align": "center"
    }
  }, [_c('vue-barcode', {
    staticClass: "barcode-font",
    attrs: {
      "value": _vm.Order.orderNumber,
      "options": {
        displayValue: false
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone #")]), _vm._v(" "), _c('td', [_vm._v(_vm._s("(866) 385-0447"))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("Shipping Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.Order.orderLab.shippingStreet) + " " + _vm._s(_vm.Order.orderLab.shippingCity) + " " + _vm._s(_vm.Order.orderLab.shippingStateCode) + " " + _vm._s(_vm.Order.orderLab.shippingPostalCode))]), _vm._v(" "), _c('th', [_vm._v("Patient")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.patLastName) + ", " + _vm._s(_vm.Order.patFirstName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("E-Order #:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.orderNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Order Ref/PO:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Order.referenceNoPo))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Submitted:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "button",
      "id": "btnPrint",
      "onclick": "javascript: window.print()",
      "value": "Print"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Order Summary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Participant Copy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Participant Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Prescription")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Sphere")]), _vm._v(" "), _c('th', [_vm._v("Cyl")]), _vm._v(" "), _c('th', [_vm._v("Axis")]), _vm._v(" "), _c('th', [_vm._v("Addition")]), _vm._v(" "), _c('th', [_vm._v("Seg. Height")]), _vm._v(" "), _c('th', [_vm._v("Dist PD")]), _vm._v(" "), _c('th', [_vm._v("Near PD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Horizontal Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("Vertical Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("OC Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title"
  }, [_vm._v("Dispensing Notes (Not Sent to Lab)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lab Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Order Summary - Lab Copy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Send this half with the frame to the lab within 1-2 business days."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Frames shipped to the wrong lab will be drastically delayed or lost.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Participant Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Prescription")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Sphere")]), _vm._v(" "), _c('th', [_vm._v("Cyl")]), _vm._v(" "), _c('th', [_vm._v("Axis")]), _vm._v(" "), _c('th', [_vm._v("Addition")]), _vm._v(" "), _c('th', [_vm._v("Seg. Height")]), _vm._v(" "), _c('th', [_vm._v("Dist PD")]), _vm._v(" "), _c('th', [_vm._v("Near PD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Additional RX Fields")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Horizontal Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("Vertical Prism")]), _vm._v(" "), _c('th', [_vm._v("Base")]), _vm._v(" "), _c('th', [_vm._v("OC Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lens Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Frame Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#eeeeee"
    }
  }, [_vm._v("Please do not add any additional order instructions or requests to this sheet. For special order requests, place the order again and check \"The lens options above do not meet the medical needs of this patient\".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Lab Information")]), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Order Identification")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47870908", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47870908"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderSummary.vue
// module id = 517
// module chunks = 4